import React, { useEffect, useState } from "react";
import { Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import Validator from "../../services/Validator";

/**
 * AddressComponent
 * 
 * form to fill address/invoice address
 * 
 * @param {customer} props - saved obejct in LocalStorage after basic registration
 * @param {setAddress} props - setter for address object in InquaryPage
 * @param {step} props - setter for step object in InquaryPage
 * 
 * @returns step change
 */
const AddressComponent = ({ setStep, data, setData, errors, setErrors }) => {


    const VALIDATOR = new Validator();

    const [showInvoiceAddress, setShowInvoiceAddress] = useState(false); // show or hide another invoice address


    /**
     * Handlers
     */
    // next handler
    const handleSubmit = (e) => {
        e.preventDefault();
        const allErrors = {};

        if (data.partner.country_id === "") allErrors.country_id = "Land muss ausgewählt sein";
        if (data.partner.country_id === "12" && data.partner.state_id === "") allErrors.state_id = "Bundesland muss ausgewählt sien";
        if (!VALIDATOR.StringLength(3, 80, data.partner.street)) allErrors.street = "Straße ist erforderlich";
        if (data.partner.houseNr === "") allErrors.houseNr = "Hausnummer ist erforderlich"
        if (!VALIDATOR.zipValid(data.partner.zip, data.partner.country_id)) allErrors.invoicePlz = "PLZ ist erforderlich";
        if (!VALIDATOR.StringLength(3, 55, data.partner.city)) allErrors.city = "Ort ist erforderlichz";

        if (Object.keys(allErrors).length > 0) {
            return setErrors(allErrors);
        }

        setStep(4)
    }


    // Views
    return (
        <Form onSubmit={e => handleSubmit(e)}>
            <Row>
                <h5 className="text-energo">Rechnungsadresse</h5>
            </Row>
            <Row className="mt-3" hidden={data.qr_code === "" || data.qr_code === null}>
                <Col xs={12} xl="12" className="text-start">
                    <Form.Group>
                        <Form.Check
                            defaultChecked={data.partner.differentAddress}
                            label="Rechnungsadresse entspricht nicht der Anlagenadresse"
                            onChange={e => setData(prev => ({...prev, 
                                partner: ({...prev.partner, differentAddress: e.target.checked})
                            }))}
                        />
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col xs="12" md="6" xl="6">
                    <Form.Group>
                        <FloatingLabel label="Land">
                            <Form.Select
                                disabled={!data.partner.differentAddress}
                                value={data.partner.country_id}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, country_id: e.target.value })
                                    }))
                                }}
                                isValid={data.partner.country_id !== ""}
                                isInvalid={errors.country_id}
                            >
                                <option value="12">Österreich</option>
                                <option value="57">Deutschland</option>
                            </Form.Select>
                        </FloatingLabel>
                        {errors.country_id ? <small className="text-danger">{errors.country_id}</small> : null}
                    </Form.Group>
                </Col>
                <Col xs="12" md="6" xl="6" hidden={data.partner.country_id !== "12"}>
                    <Form.Group>
                        <FloatingLabel label="Bundesland">
                            <Form.Select
                                disabled={!data.partner.differentAddress}
                                value={data.partner.state_id}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, state_id: e.target.value })
                                    }))
                                }}
                                isValid={(data.partner.country_id === "12" && data.partner.state_id !== "") || data.partner.country_id === "57"}
                                isInvalid={errors.state_id}
                            >
                                <option value=""></option>
                                <option value="1436">Burgenland</option>
                                <option value="1437">Kärnten</option>
                                <option value="1438">Niederösterreich</option>
                                <option value="1439">Oberösterreich</option>
                                <option value="1440">Salzburg</option>
                                <option value="1441">Steiermark</option>
                                <option value="1442">Tirol</option>
                                <option value="1443">Vorarlberg</option>
                                <option value="1444">Wien</option>∏
                            </Form.Select>
                        </FloatingLabel>
                        {errors.state_id ? <small className="text-danger">{errors.state_id}</small> : null}
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mt-3 text-start">
                <Col xs="12" md="12" xl="8">
                    <Form.Group>
                        <FloatingLabel label="Straße">
                            <Form.Control
                                type="text"
                                disabled={!data.partner.differentAddress}
                                placeholder="Straße"
                                value={data.partner.street}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, street: e.target.value })
                                    }))
                                }}
                                isValid={data.partner.street !== "" && data.partner.street.length > 3}
                                isInvalid={errors.street}
                            />
                        </FloatingLabel>
                        {errors.street ? <small className="text-danger">{errors.street}</small> : null}
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="8" md="4" xl="4">
                    <Form.Group>
                        <FloatingLabel label="Hausnummer">
                            <Form.Control
                                type="text"
                                disabled={!data.partner.differentAddress}
                                placeholder="Hausnummer"
                                value={data.partner.houseNr}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, houseNr: e.target.value })
                                    }))
                                }}
                                isValid={data.partner.houseNr !== ""}
                                isInvalid={errors.houseNr}
                            />
                        </FloatingLabel>
                        {errors.houseNr ? <small className="text-danger">{errors.houseNr}</small> : null}
                    </Form.Group>
                </Col>
                <Col xs="8" md="4" xl="4">
                    <Form.Group>
                        <FloatingLabel label="Stiege">
                            <Form.Control
                                type="text"
                                disabled={!data.partner.differentAddress}
                                placeholder="Stiege"
                                value={data.partner.stiege}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, stiege: e.target.value })
                                    }))
                                }}
                                isValid={data.partner.stiege !== ""}
                            />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col xs="8" md="4" xl="4">
                    <Form.Group>
                        <FloatingLabel label="Top">
                            <Form.Control
                                type="text"
                                disabled={!data.partner.differentAddress}
                                placeholder="Top"
                                value={data.partner.top}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, top: e.target.value })
                                    }))
                                }}
                                isValid={data.partner.top !== ""}
                            />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col xs="12" md="3" xl="4">
                    <Form.Group>
                        <FloatingLabel label="PLZ">
                            <Form.Control
                                type="text"
                                disabled={!data.partner.differentAddress}
                                placeholder="0000"
                                value={data.partner.zip}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, zip: e.target.value })
                                    }))
                                }}
                                isValid={VALIDATOR.zipValid(data.partner.zip, data.partner.country_id)}
                                isInvalid={errors.zip}
                            />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col xs="12" md="9" xl="8">
                    <Form.Group>
                        <FloatingLabel label="Ort">
                            <Form.Control
                                type="text"
                                disabled={!data.partner.differentAddress}
                                placeholder="Ort"
                                value={data.partner.city}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, city: e.target.value })
                                    }))
                                }}
                                isValid={data.partner.city !== "" && data.partner.city.length > 3}
                                isInvalid={errors.city}
                            />
                        </FloatingLabel>
                        {errors.city ? <small className="text-danger">{errors.city}</small> : null}
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col className="text-end">
                    <Button variant="warning" onClick={() => setStep(2)} style={{ marginRight: 5 }}>Zurück</Button>
                    <Button type="submit" className="btn-energo">Weiter</Button>
                </Col>
            </Row>
        </Form>
    )

}

export default AddressComponent;